(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ZXing", [], factory);
	else if(typeof exports === 'object')
		exports["ZXing"] = factory();
	else
		root["ZXing"] = factory();
})(window, function() {
return 